import type { PropsWithChildren, ReactElement } from "react";

import { ScrollArea } from "@similarweb/ui-components";

import OnboardingHubHeader from "app/pages/sales-intelligence/sub-modules/onboarding/sidebar-hub/components/OnboardingHubHeader/OnboardingHubHeader";
import type { OnboardingHubProgressBaseProps } from "app/pages/sales-intelligence/sub-modules/onboarding/sidebar-hub/components/OnboardingHubProgress/OnboardingHubProgress";
import {
    OnboardingHubHeaderWrapper,
    StyledOnboardingHubContent,
    StyledShadowBlock,
    StyledShadowBlockBottomCover,
    StyledShadowBlockTopCover,
} from "app/pages/sales-intelligence/sub-modules/onboarding/sidebar-hub/containers/styles";

export interface OnboardingHubContentWrapperProps extends OnboardingHubProgressBaseProps {
    onCloseHub: () => void;
    inSidebar: boolean;
}

const OnboardingHubContentWrapper = ({
    children,
    onCloseHub,
    inSidebar,
    ...progressProps
}: PropsWithChildren<OnboardingHubContentWrapperProps>): ReactElement => (
    <StyledOnboardingHubContent inSidebar={inSidebar}>
        {!inSidebar ? <div>
                <OnboardingHubHeaderWrapper>
                    <OnboardingHubHeader
                        key="OnboardingHubHeader"
                        isExtended
                        isShowClose
                        onClose={onCloseHub}
                        {...progressProps}
                    />
                </OnboardingHubHeaderWrapper>
                <StyledShadowBlockTopCover />
                <StyledShadowBlock />
            </div> : null}

        <ScrollArea
            verticalScrollbarStyle={{ borderRadius: 4, width: 8 }}
            smoothScrolling
            minScrollSize={40}
        >
            {!inSidebar ? <StyledShadowBlockBottomCover /> : null}

            {children}
        </ScrollArea>
    </StyledOnboardingHubContent>
);

export default OnboardingHubContentWrapper;
